import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { AppProfileInjection } from "features/appProfileRegister/di/AppProfieInjection";
import { isEmpty } from "lodash";
import { injectable } from "tsyringe";
import { ProfileStatusEnum } from "utils/enums/AppProfileEnum";
import { DateFormat } from "utils/format/DateFormat";
import { paramsChecking } from "utils/helpersInTs/helpersInTs";
import { AppProfileRequestEntity } from "../entities/AppProfileRequestEntity";
import { AppProfileResponseEntity } from "../entities/AppProfileResponseEntity";
import { AppProfileVerificationEntity } from "../entities/AppProfileVerificationEntity";
import { IAppProfileRepository } from "../repositories/IAppProfileRepository";

@injectable()
export class AppProfileUseCase {
  private appProfileRepo: IAppProfileRepository;
  constructor() {
    this.appProfileRepo = AppProfileInjection.getRepo();
  }

  private checkParams(values: AppProfileRequestEntity) {
    let params = {
      ...values,
      status: isEmpty(String(values?.status))
        ? undefined
        : values?.status === ProfileStatusEnum.Approved
          ? 2
          : values?.status,
      type: isEmpty(String(values?.type)) ? undefined : values?.type,
      code: paramsChecking(values?.code, "input"),
      phoneNumber: paramsChecking(values?.phoneNumber, "input"),
      providerPreviewCode:
        values?.providerPreviewCode === ""
          ? undefined
          : values?.providerPreviewCode,
      isVerified: new AppProfileRequestEntity().getIsVerifiedParam(
        values?.status,
      ),
      typeContract: isEmpty(values?.typeContract)
        ? undefined
        : values?.typeContract,
      fromDate: !!values?.date
        ? DateFormat.dateRendering(values?.date, "from")
        : values?.fromDate,
      toDate: !!values?.date
        ? DateFormat.dateRendering(values?.date, "to")
        : values?.toDate,
    };
    delete params?.date;
    return params;
  }

  async getProfileList(
    params: AppProfileRequestEntity,
  ): Promise<ListBaseApiResponseModel<AppProfileResponseEntity>> {
    const updatedParams = this.checkParams(params);
    return await this.appProfileRepo.getProfileList(updatedParams);
  }

  async getProfileDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<AppProfileResponseEntity>> {
    return await this.appProfileRepo.getProfileDetail(params);
  }

  async verifyProfile(
    params: AppProfileVerificationEntity,
  ): Promise<BaseApiResponseModel<AppProfileResponseEntity>> {
    return await this.appProfileRepo.verifyProfile(params);
  }

  async syncStatus(params: {
    id: string;
  }): Promise<BaseApiResponseModel<AppProfileResponseEntity>> {
    return await this.appProfileRepo.syncStatus(params);
  }

  async syncAllStatus(): Promise<BaseApiResponseModel<any>> {
    return await this.appProfileRepo.syncAllStatus();
  }

  async exportExcel(params: AppProfileRequestEntity): Promise<Blob> {
    delete params?.page;
    delete params?.limit;
    const updatedParams = this.checkParams(params);
    return await this.appProfileRepo.exportExcel(updatedParams);
  }

  async downLoadZip(id: string): Promise<Blob> {
    return await this.appProfileRepo.downLoadZip(id);
  }
}
